const LinearProgress = ({
  percentage,
  height,
  children
}: {
  percentage: number;
  height?: number;
  children?: React.ReactNode;
}) => {
  const h = height || 8;
  return (
    <div
      style={{
        borderRadius: h / 2,
        backgroundColor: '#E0E0E0',
        overflow: 'hidden',
        marginTop: 10,
        marginBottom: 10,
        width: '100%'
      }}
    >
      <div
        style={{
          backgroundColor: '#27CE5A',
          height: `${h}px`,
          lineHeight: `${h}px`,
          width: `${percentage}%`,
          transition: 'width 0.5s'
        }}
      >
        {children}
      </div>
    </div>
  );
};
export default LinearProgress;
